import { z } from "zod"

export type SeempActionDefinition = {
	id: number
	type: string
	description: string
	unit: string
	yAxisLabel: string
	optimization: "minimize" | "maximize"
	isTrendLogicImplemented: boolean
	createdByUserId: number
	createdAt: Date
}

export type SeempActionGroup = {
	id: number
	label: string
	description: string
	opModesIds: number[]
	actionsDefinitions: SeempActionDefinition[]
}

export type SeempSchemaConfigFE = {
	id: number
	label: string
	//opModeSchemaId: string
	plants: { id: number; name: string }[]
	allowedPlants: { id: number; name: string }[]
	actionGroups: SeempActionGroup[]
}

export const NewGroupForm = z.object({
	label: z.string().trim().min(1, "Label is required"),
	description: z.string().trim().min(1, "Description is required"),
	opModeIds: z.array(z.number()).min(1, "Select at least one op mode"),
})
